import { render, staticRenderFns } from "./CreateNewQuote.vue?vue&type=template&id=96e2cbac&scoped=true&"
import script from "./CreateNewQuote.vue?vue&type=script&lang=js&"
export * from "./CreateNewQuote.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewQuote.vue?vue&type=style&index=0&id=96e2cbac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e2cbac",
  null
  
)

export default component.exports